import { Box, Grid, Typography, Backdrop, CircularProgress } from '@mui/material';
import AppHeader from '@/components/Elements/Header/AppHeader';

// 長時間ローディング用
export const LongLoading = () => {
  return (
    <>
      <Backdrop
        sx={{ color: '#fff', backgroundColor: '#0003', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={true}
        className="flex flex-col"
      >
        <Grid>
          <Typography className="text-2xl font-semibold" color={'inherit'}>
            データ処理中です
          </Typography>
        </Grid>

        <Grid sx={{ p: 4 }}>
          <CircularProgress color={'inherit'} />
        </Grid>
        <Grid className="text-center">
          <Typography color={'inherit'} className="font-semibold">
            画面を更新せず、
          </Typography>
          <Typography color={'inherit'} className="font-semibold">
            そのままお待ちください。
          </Typography>
          <Typography color={'inherit'} className="font-semibold">
            完了まで数十秒かかる場合があります。
          </Typography>
        </Grid>
      </Backdrop>
    </>
  );
};
